export const countriesMapper = (countries = [], filterUnitedStates = false) => {
  const mapped = countries.map((country) => ({
    label: country?.displayName,
    value: country?.isoCode2,
  }))
  if (filterUnitedStates) {
    return mapped.filter(({ value }) => value !== 'US')
  } else {
    return mapped
  }
}
